import { Context } from '@front10/helpers/dist/Context';
import { useContext } from 'react';

export function useContainerContext() {
  return useContext(Context);
}
